// 常见问题
<template>
  <div class="cjwt width1200" role="tablist">
    <div class="item">
      <p class="title">超级HTTP隧道代理常见问题</p>
      <div class="item-list">
        <div class="collapse-ans">
          本页面提供关于超级HTTP代理隧道的一些常见问题的解答，如果您在使用过程中遇到问题，可以参阅。此外，您也可以在相关技术支持群里寻求帮助。
        </div>
      </div>
    </div>
    <div class="item" v-for="(item, index) in cjwtList" :key="index">
      <p class="title">{{ item.title }}</p>
      <div class="item-list">
        <div
          v-for="(accordion, accordionIndex) in item.data"
          :key="accordionIndex"
        >
          <div
            class="collapse-title d-flex d-flex-aic d-flex-jc-sb"
            :class="tabs == `${index}-${accordionIndex}` ? 'active' : ''"
            @click="collapseChange(index, accordionIndex)"
          >
            <span>{{ accordion.req }}</span>
            <img
              :src="
                require(tabs == `${index}-${accordionIndex}`
                  ? '@/assets/images/icon12.png'
                  : '@/assets/images/icon11.png')
              "
              alt=""
            />
          </div>
          <div
            class="collapse-ans"
            :style="{
              display: tabs == `${index}-${accordionIndex}` ? 'block' : 'none',
            }"
          >
            {{ accordion.ans }}
            <!--{{ (tabs, `${index}-${accordionIndex}`) }}-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: "0-0",
      cjwtList: [
        {
          title: "功能相关问题",
          data: [
            {
              req: "白名单添加后代理无法访问",
              ans: "分布式中心同步数据需要等待几分钟",
            },
            {
              req: "实际代理出口IP和提取接口返回出口IP差异",
              ans: "边缘设备更新IP后中心数据更新延迟导致，不影响实际使用",
            },
            {
              req: "什么是通道数？",
              ans: "通道数就是能自定义多少sessionID，通道数等于账号对应的并发数",
            },
            {
              req: "并发数定义",
              ans: "指的是一秒内发起的所有请求数之和，如果超出账号限制的值，那么多出的部分会被拒绝访问，这时候需要购买更多的请求数以满足业务需求。所有session共享账号并发数",
            },
            {
              req: "带宽相关",
              ans: "所有session共享账号带宽",
            },
            {
              req: "去重周期",
              ans: "一个自然天内去重，所有session共享去重",
            }
          ],
        },
        {
          title: "IP池相关问题",
          data: [
            {
              req: "池子里的代理IP都是在网上采集的免费代理吗？",
              ans: "不是的，多贝云所有的动态IP的来源都是基于家庭宽带线路自建的，我们会在全国各地拉ADSL线路进入到IDC机房，再通过专用网络设备接入到平台",
            },
            {
              req: "总池子多少IP？",
              ans: "目前池子里面总共有500万的IP，并且每周都会进行优化调整",
            },
            {
              req: "地区分布如何？",
              ans: "分布在全国24个省份直辖市，上百个城市节点，并且持续在增加",
            },
          ],
        },
        {
          title: "购买相关问题",
          data: [
            {
              req: "带宽或者并发数能够在默认账号基础上额外增加吗？",
              ans: "按天购买的账号支持升级并发数。按月购买的账号支持升级带宽、并发数",
            },
            {
              req: "可以免费测试吗？",
              ans: "可以，请联系商务人员",
            },
            {
              req: "是否可以开具发票？",
              ans: "可以，消费累计达到2000元或以上即可",
            },
            {
              req: "是否可以签订合同？",
              ans: "可以",
            },
          ],
        },
      ],
    };
  },
  methods: {
    collapseChange(index, accordionIndex) {
      this.tabs = `${index}-${accordionIndex}`;
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/cjwt.less";
</style>
